import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import * as UI from '../../../ui';
import { Office } from 'modules/offices';

import { Links } from '../../consts';

const { Text } = UI;

const ShowOnMapMarker = ({ styles, rules, office }) => {
    const link = Links[office.toUpperCase()];

    return (
        <a href={link} target="_blank" rel="noopener noreferrer" className={styles.mainContainer}>
            <div className={styles.container}>
                <Text extend={rules.extendText}>
                    <FormattedMessage id="contact.map.cta" />
                </Text>
            </div>
            <div className={styles.triangle} />
        </a>
    );
};

ShowOnMapMarker.propTypes = {
    styles: PropTypes.shape().isRequired,
    rules: PropTypes.shape().isRequired,
    office: PropTypes.oneOf(Object.values(Office)).isRequired,
};

export default ShowOnMapMarker;
